import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { UserCircle, House, Tag } from "@phosphor-icons/react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { useApp } from "@/context/AppContext";

const ICONS = [House, UserCircle, Tag];

export function Onboarding() {
  const { t } = useApp();
  const navigate = useNavigate();
  const [open, setOpen] = useState(!localStorage.getItem("sb_onboarded"));
  const [step, setStep] = useState(0);
  const steps = [
    { title: t("onbTitle1"), text: t("onbText1") },
    { title: t("onbTitle2"), text: t("onbText2") },
    { title: t("onbTitle3"), text: t("onbText3") },
  ];

  const finish = () => { localStorage.setItem("sb_onboarded", "1"); setOpen(false); };
  const Icon = ICONS[step];
  const last = step === steps.length - 1;

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) finish(); }}>
      <DialogContent data-testid="onboarding-modal" className="text-center">
        <DialogHeader className="sr-only">
          <DialogTitle>SafeBuddy Onboarding</DialogTitle>
          <DialogDescription>Kurze Einführung in SafeBuddy</DialogDescription>
        </DialogHeader>
        <div className="flex flex-col items-center gap-4 py-2">
          <div className="p-5 rounded-3xl border-2 border-gray-800 sb-float" style={{ background: "var(--app-primary)" }}>
            <Icon size={44} weight="duotone" color="#fff" />
          </div>
          <h2 className="text-2xl font-heading font-semibold text-gray-900">{steps[step].title}</h2>
          <p className="font-body text-gray-800 leading-relaxed">{steps[step].text}</p>
          <div className="flex gap-1.5 mt-1">
            {steps.map((_, i) => (
              <span key={i} className="w-2.5 h-2.5 rounded-full border-2 border-gray-800" style={{ background: i === step ? "var(--app-primary)" : "#fff" }} />
            ))}
          </div>
          <div className="flex gap-2 w-full mt-2">
            <button data-testid="onboarding-skip" onClick={finish} className="sb-btn flex-1 py-3 bg-white font-medium">{t("skip")}</button>
            <button data-testid="onboarding-next" onClick={() => (last ? finish() : setStep(step + 1))}
              className="sb-btn flex-1 py-3 text-white font-medium" style={{ background: "var(--app-primary)" }}>
              {last ? t("getStarted") : t("next")}
            </button>
          </div>
          {last && (
            <button data-testid="onboarding-guide" onClick={() => { finish(); navigate("/guide"); }}
              className="text-sm font-heading underline mt-1" style={{ color: "var(--app-strong)" }}>{t("onbViewGuide")} →</button>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
